







































import {
  BankCustodian,
  DebitCardCustomization,
} from "@/admin/types";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { CardCustomization } from "@/admin/route-names";
import { useCardCustomizationStore } from "@/admin/store/cardCustomization";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class CardCustomizationSection extends Vue {
  CardCustomization = CardCustomization;

  @Prop() partnerId: number;
  @Prop() custodian: BankCustodian;

  selectedCardCustomization?: DebitCardCustomization = null;
  isSaving = false;

  cardCustomizationStore = useCardCustomizationStore();

  mounted () {
    this.onPartnerIdChange();
    this.onPartnerCardCustomizationLoaded();
  }

  get canCustomize () {
    return this.cardCustomizationStore.canCustomizeCards(this.custodian);
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    if (this.canCustomize) {
      this.cardCustomizationStore.loadCardCustomizations(this.custodian);
      this.cardCustomizationStore.getPartnerCardCustomization(this.partnerId);
    }
  }

  @Watch("isLoading")
  onPartnerCardCustomizationLoaded () {
    if (!this.isLoading) {
      this.selectedCardCustomization = this.currentCustomization;
    }
  }

  get isLoading () {
    return this.cardCustomizationStore.isLoadingCardCustomizations ||
        this.cardCustomizationStore.isLoadingPartnerCardCustomization(this.partnerId);
  }

  get customizationOptions () {
    return this.cardCustomizationStore.cardCustomizations.map(cc => ({
      value: cc,
      text: cc.cardStockNickname
    }));
  }

  get currentCustomization () {
    return this.cardCustomizationStore.partnerCardCustomization(this.partnerId);
  }

  get opaqueId () {
    return this.selectedCardCustomization ? this.selectedCardCustomization.cardStockOpaqueId : "";
  }

  onSave () {
    if (!this.selectedCardCustomization || this.selectedCardCustomization === this.currentCustomization) {
      return;
    }

    this.isSaving = true;
    this.cardCustomizationStore.setPartnerCardCustomization({
          partnerId: this.partnerId,
          custodian: this.custodian,
          customizationId: this.selectedCardCustomization.customizationId
        })
        .finally(() => {
          this.isSaving = false;
        });
  }
}
